// PERSONA FRAGRANCE INTELLIGENCE — i18n dictionary
// Brand names are NEVER translated: PERSONA FRAGRANCE INTELLIGENCE, PERSONA AI PERFUMER, PERSONA PERFUMERY TECH, PERSONA CORE
import { P2 } from "@/i18n/translations_p2";
import { P22 } from "@/i18n/translations_p22";
import { P23 } from "@/i18n/translations_p23";
import { P24 } from "@/i18n/translations_p24";
import { P5 } from "@/i18n/translations_p5";

export const LANGUAGES = [
  { code: "id", label: "Bahasa Indonesia", short: "ID", flag: "ID" },
  { code: "en", label: "English", short: "EN", flag: "EN" },
  { code: "fr", label: "Français", short: "FR", flag: "FR" },
];

const t = {
  en: {
    // Nav
    nav_dashboard: "Dashboard",
    nav_ai_perfumer: "PERSONA AI PERFUMER",
    nav_profile: "My AI Profile",
    nav_history: "AI Conversation History",
    nav_subscription: "My Subscription",
    nav_account: "Account",
    nav_tech: "PERSONA PERFUMERY TECH",
    nav_signin: "Sign In",
    nav_signup: "Get Started",
    nav_signout: "Sign out",

    // Landing hero
    hero_tagline: "The Intelligence Behind Personalized Fragrance",
    hero_headline_a: "Where artificial intelligence,",
    hero_headline_b: "fragrance knowledge, and",
    hero_headline_c: "personalized perfumery",
    hero_headline_d: "come together.",
    hero_cta_primary: "EXPLORE PERSONA AI PERFUMER",
    hero_cta_secondary: "DISCOVER PERSONA PERFUMERY TECH",
    heritage_badge: "Built in Indonesia. Designed for the World.",

    // What is
    what_is_eyebrow: "The Platform",
    what_is_title: "What is PERSONA FRAGRANCE INTELLIGENCE?",
    what_is_body:
      "A premium fragrance intelligence platform combining artificial intelligence, deep perfumery knowledge, and personalized fragrance technology — engineered for the next era of scent discovery.",

    // Two products section
    products_eyebrow: "Two Products, One Ecosystem",
    products_title: "AI intelligence meets official fragrance technology.",
    product_ai_subtitle: "AI-Powered Fragrance Intelligence",
    product_ai_desc:
      "Explore fragrance knowledge, receive intelligent fragrance consultation, and discover your fragrance preferences through AI-powered conversation.",
    product_ai_cta: "ENTER PERSONA AI PERFUMER",
    product_tech_subtitle: "Official Personalized Fragrance Technology",
    product_tech_desc:
      "Access the official PERSONA personalized fragrance research and formulation technology.",
    product_tech_cta: "ACCESS PERSONA PERFUMERY TECH",

    // Ecosystem
    eco_eyebrow: "How the ecosystem works",
    eco_title: "One intelligent ecosystem. Two core technologies.",
    eco_ai_role: "AI Intelligence",
    eco_ai_kb: "Knowledge Base",
    eco_ai_cons: "Consultation",
    eco_ai_rec: "Recommendations",
    eco_tech_role: "Official Technology",
    eco_tech_core: "PERSONA CORE",
    eco_tech_res: "Official Research",
    eco_tech_form: "Official Formula",
    eco_core_note: "PERSONA CORE remains a protected proprietary black box.",

    // Why
    why_eyebrow: "Why it matters",
    why_title: "Personalized fragrance, elevated by intelligence.",
    why_body:
      "Traditional fragrance consultation is manual, inconsistent, and difficult to scale. PERSONA AI PERFUMER brings structured, intelligent, on-demand fragrance guidance to everyone — anywhere in the world.",

    // AI power
    ai_eyebrow: "AI-powered fragrance intelligence",
    ai_title: "A consultation experience, not a chatbot.",
    ai_bullet_1: "Discover your fragrance families",
    ai_bullet_2: "Understand notes, accords & structures",
    ai_bullet_3: "Build a living AI Fragrance Profile",
    ai_bullet_4: "Speaks Bahasa Indonesia, English & Français",

    // Subscription teaser
    sub_eyebrow: "Membership",
    sub_title: "Choose the tier of your olfactory journey.",
    sub_free: "Free",
    sub_free_desc: "Begin your fragrance discovery.",
    sub_pro: "Pro",
    sub_pro_desc: "For serious fragrance enthusiasts.",
    sub_enterprise: "Enterprise",
    sub_enterprise_desc: "For professionals and boutiques.",

    // FAQ
    faq_title: "Frequently asked",
    faq_q1: "Is PERSONA AI PERFUMER the same as PERSONA CORE?",
    faq_a1:
      "No. PERSONA AI PERFUMER is an AI fragrance consultant. PERSONA CORE is the protected proprietary technology behind PERSONA PERFUMERY TECH and is not exposed here.",
    faq_q2: "Does the AI generate my official PERSONA formula?",
    faq_a2:
      "No. The AI provides fragrance intelligence and guidance only. Official personalized fragrance results come from PERSONA PERFUMERY TECH.",
    faq_q3: "Which languages are supported?",
    faq_a3: "Bahasa Indonesia, English, and Français — with more coming.",
    faq_q4: "Do I need to share biometric data to register?",
    faq_a4: "No. Registration is intentionally simple.",

    // CTA footer
    final_cta_title: "Begin your fragrance intelligence journey.",
    final_cta_sub: "Two products. One elegant ecosystem. Global-grade craftsmanship.",
    final_cta_button: "Create your account",

    // Auth
    auth_signin_title: "Sign in",
    auth_signin_sub: "Continue your fragrance intelligence journey.",
    auth_signup_title: "Create your account",
    auth_signup_sub: "Begin exploring PERSONA FRAGRANCE INTELLIGENCE.",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Full name",
    auth_signin_btn: "Sign in",
    auth_signup_btn: "Create account",
    auth_google: "Continue with Google",
    auth_or: "or",
    auth_no_account: "New here?",
    auth_have_account: "Already have an account?",
    auth_error: "Something went wrong. Please try again.",

    // Dashboard
    dash_welcome: "Welcome to your fragrance intelligence journey.",
    dash_hello: "Bonjour",
    dash_ai_card_title: "PERSONA AI PERFUMER",
    dash_ai_card_sub: "AI-Powered Fragrance Intelligence",
    dash_ai_card_desc:
      "Explore fragrance knowledge, receive intelligent consultation, and discover your preferences through AI-powered conversation.",
    dash_tech_card_title: "PERSONA PERFUMERY TECH",
    dash_tech_card_sub: "Official Personalized Fragrance Technology",
    dash_tech_card_desc:
      "Access the official PERSONA personalized fragrance research and formulation technology.",
    dash_stat_conversations: "Consultations",
    dash_stat_messages: "AI Messages",
    dash_stat_plan: "Current Plan",

    // AI Perfumer page
    ai_page_title: "PERSONA AI PERFUMER",
    ai_page_sub: "Your Intelligent Fragrance Consultant",
    ai_input_placeholder: "Ask your fragrance question…",
    ai_send: "Send",
    ai_new_conversation: "New consultation",
    ai_suggestions_title: "Try asking",
    ai_sugg_1: "What fragrance style suits me?",
    ai_sugg_2: "What are the differences between woody and floral fragrances?",
    ai_sugg_3: "Help me discover my fragrance preferences.",
    ai_sugg_4: "Which fragrance notes might I enjoy?",
    ai_sugg_5: "Teach me about fragrance families.",
    ai_disclaimer:
      "PERSONA AI PERFUMER provides AI fragrance guidance. For your official personalized fragrance result, use PERSONA PERFUMERY TECH.",
    ai_thinking: "Composing your consultation…",

    // Profile
    profile_title: "My AI Profile",
    profile_sub: "AI Fragrance Profile — not the official PERSONA CORE profile.",
    profile_families: "Preferred Fragrance Families",
    profile_favs: "Favorite Notes",
    profile_dislikes: "Disliked Notes",
    profile_style: "Fragrance Style",
    profile_intensity: "Preferred Intensity",
    profile_occasion: "Preferred Occasion",
    profile_summary: "AI Consultation Summary",
    profile_save: "Save profile",
    profile_saved: "Profile saved.",
    profile_add: "Add",

    // History
    hist_title: "AI Conversation History",
    hist_sub: "Your past consultations with PERSONA AI PERFUMER.",
    hist_empty: "No conversations yet. Start your first consultation.",
    hist_open: "Open",
    hist_rename: "Rename",
    hist_delete: "Delete",
    hist_rename_prompt: "New title",

    // Subscription
    sub_page_title: "My Subscription",
    sub_current_plan: "Current Plan",
    sub_status: "Status",
    sub_renewal: "Renewal date",
    sub_usage: "AI usage",
    sub_upgrade: "Upgrade plan",
    sub_soon: "Upgrades available soon.",

    // Perfumery Tech gateway
    tech_title: "PERSONA PERFUMERY TECH",
    tech_headline: "Official Personalized Fragrance Technology",
    tech_desc:
      "Access the official PERSONA personalized fragrance research and formulation technology.",
    tech_distinction_ai:
      "PERSONA AI PERFUMER = AI-powered fragrance intelligence and consultation.",
    tech_distinction_tech:
      "PERSONA PERFUMERY TECH = Official PERSONA personalized fragrance technology.",
    tech_distinction_core:
      "PERSONA CORE = Protected proprietary technology behind PERSONA PERFUMERY TECH.",
    tech_cta: "ACCESS OFFICIAL PERSONA TECHNOLOGY",

    // Common
    loading: "Loading…",
    back: "Back",
  },

  id: {
    nav_dashboard: "Dasbor",
    nav_ai_perfumer: "PERSONA AI PERFUMER",
    nav_profile: "Profil AI Saya",
    nav_history: "Riwayat Konsultasi AI",
    nav_subscription: "Langganan Saya",
    nav_account: "Akun",
    nav_tech: "PERSONA PERFUMERY TECH",
    nav_signin: "Masuk",
    nav_signup: "Mulai",
    nav_signout: "Keluar",

    hero_tagline: "Intelijen di Balik Wewangian Personal",
    hero_headline_a: "Tempat kecerdasan buatan,",
    hero_headline_b: "pengetahuan wewangian, dan",
    hero_headline_c: "perfumery personal",
    hero_headline_d: "menyatu.",
    hero_cta_primary: "JELAJAHI PERSONA AI PERFUMER",
    hero_cta_secondary: "TEMUKAN PERSONA PERFUMERY TECH",
    heritage_badge: "Dibangun di Indonesia. Dirancang untuk Dunia.",

    what_is_eyebrow: "Platform",
    what_is_title: "Apa itu PERSONA FRAGRANCE INTELLIGENCE?",
    what_is_body:
      "Platform intelijen wewangian premium yang menggabungkan kecerdasan buatan, pengetahuan perfumery mendalam, dan teknologi wewangian personal — dirancang untuk era baru penemuan aroma.",

    products_eyebrow: "Dua Produk, Satu Ekosistem",
    products_title: "Intelijen AI bertemu teknologi wewangian resmi.",
    product_ai_subtitle: "Intelijen Wewangian Bertenaga AI",
    product_ai_desc:
      "Jelajahi pengetahuan wewangian, dapatkan konsultasi cerdas, dan temukan preferensi wewangian Anda melalui percakapan AI.",
    product_ai_cta: "MASUK KE PERSONA AI PERFUMER",
    product_tech_subtitle: "Teknologi Wewangian Personal Resmi",
    product_tech_desc:
      "Akses teknologi riset dan formulasi wewangian personal resmi PERSONA.",
    product_tech_cta: "AKSES PERSONA PERFUMERY TECH",

    eco_eyebrow: "Cara ekosistem bekerja",
    eco_title: "Satu ekosistem cerdas. Dua teknologi inti.",
    eco_ai_role: "Intelijen AI",
    eco_ai_kb: "Basis Pengetahuan",
    eco_ai_cons: "Konsultasi",
    eco_ai_rec: "Rekomendasi",
    eco_tech_role: "Teknologi Resmi",
    eco_tech_core: "PERSONA CORE",
    eco_tech_res: "Riset Resmi",
    eco_tech_form: "Formula Resmi",
    eco_core_note: "PERSONA CORE tetap menjadi kotak hitam proprietari yang terlindungi.",

    why_eyebrow: "Mengapa ini penting",
    why_title: "Wewangian personal, ditingkatkan oleh intelijen.",
    why_body:
      "Konsultasi wewangian tradisional bersifat manual, tidak konsisten, dan sulit diskalakan. PERSONA AI PERFUMER menghadirkan panduan wewangian yang terstruktur, cerdas, dan on-demand untuk semua orang — di mana pun di dunia.",

    ai_eyebrow: "Intelijen wewangian bertenaga AI",
    ai_title: "Pengalaman konsultasi, bukan chatbot.",
    ai_bullet_1: "Temukan keluarga wewangian Anda",
    ai_bullet_2: "Pahami notes, accord & struktur",
    ai_bullet_3: "Bangun AI Fragrance Profile yang hidup",
    ai_bullet_4: "Bahasa Indonesia, English & Français",

    sub_eyebrow: "Keanggotaan",
    sub_title: "Pilih tingkat perjalanan olfaktori Anda.",
    sub_free: "Gratis",
    sub_free_desc: "Mulai penemuan wewangian Anda.",
    sub_pro: "Pro",
    sub_pro_desc: "Untuk penggemar wewangian yang serius.",
    sub_enterprise: "Enterprise",
    sub_enterprise_desc: "Untuk profesional dan butik.",

    faq_title: "Pertanyaan umum",
    faq_q1: "Apakah PERSONA AI PERFUMER sama dengan PERSONA CORE?",
    faq_a1:
      "Tidak. PERSONA AI PERFUMER adalah konsultan wewangian AI. PERSONA CORE adalah teknologi proprietari terlindungi di balik PERSONA PERFUMERY TECH dan tidak diekspos di sini.",
    faq_q2: "Apakah AI menghasilkan formula PERSONA resmi saya?",
    faq_a2:
      "Tidak. AI hanya menyediakan intelijen dan panduan wewangian. Hasil wewangian personal resmi berasal dari PERSONA PERFUMERY TECH.",
    faq_q3: "Bahasa apa yang didukung?",
    faq_a3: "Bahasa Indonesia, English, dan Français — dan akan bertambah.",
    faq_q4: "Apakah saya perlu berbagi data biometrik untuk mendaftar?",
    faq_a4: "Tidak. Proses pendaftaran sengaja dibuat sederhana.",

    final_cta_title: "Mulai perjalanan intelijen wewangian Anda.",
    final_cta_sub: "Dua produk. Satu ekosistem yang elegan. Kualitas berkelas dunia.",
    final_cta_button: "Buat akun Anda",

    auth_signin_title: "Masuk",
    auth_signin_sub: "Lanjutkan perjalanan intelijen wewangian Anda.",
    auth_signup_title: "Buat akun",
    auth_signup_sub: "Mulai jelajahi PERSONA FRAGRANCE INTELLIGENCE.",
    auth_email: "Email",
    auth_password: "Kata sandi",
    auth_name: "Nama lengkap",
    auth_signin_btn: "Masuk",
    auth_signup_btn: "Buat akun",
    auth_google: "Lanjutkan dengan Google",
    auth_or: "atau",
    auth_no_account: "Baru di sini?",
    auth_have_account: "Sudah punya akun?",
    auth_error: "Terjadi kesalahan. Silakan coba lagi.",

    dash_welcome: "Selamat datang di perjalanan intelijen wewangian Anda.",
    dash_hello: "Halo",
    dash_ai_card_title: "PERSONA AI PERFUMER",
    dash_ai_card_sub: "Intelijen Wewangian Bertenaga AI",
    dash_ai_card_desc:
      "Jelajahi pengetahuan wewangian, dapatkan konsultasi cerdas, dan temukan preferensi Anda melalui percakapan AI.",
    dash_tech_card_title: "PERSONA PERFUMERY TECH",
    dash_tech_card_sub: "Teknologi Wewangian Personal Resmi",
    dash_tech_card_desc:
      "Akses teknologi riset dan formulasi wewangian personal resmi PERSONA.",
    dash_stat_conversations: "Konsultasi",
    dash_stat_messages: "Pesan AI",
    dash_stat_plan: "Paket Aktif",

    ai_page_title: "PERSONA AI PERFUMER",
    ai_page_sub: "Konsultan Wewangian Cerdas Anda",
    ai_input_placeholder: "Ajukan pertanyaan wewangian Anda…",
    ai_send: "Kirim",
    ai_new_conversation: "Konsultasi baru",
    ai_suggestions_title: "Coba tanya",
    ai_sugg_1: "Gaya wewangian apa yang cocok untuk saya?",
    ai_sugg_2: "Apa perbedaan wewangian woody dan floral?",
    ai_sugg_3: "Bantu saya menemukan preferensi wewangian saya.",
    ai_sugg_4: "Notes wewangian apa yang mungkin saya sukai?",
    ai_sugg_5: "Ajari saya tentang keluarga wewangian.",
    ai_disclaimer:
      "PERSONA AI PERFUMER menyediakan panduan wewangian AI. Untuk hasil wewangian personal resmi Anda, gunakan PERSONA PERFUMERY TECH.",
    ai_thinking: "Menyusun konsultasi Anda…",

    profile_title: "Profil AI Saya",
    profile_sub: "AI Fragrance Profile — bukan profil resmi PERSONA CORE.",
    profile_families: "Keluarga Wewangian Favorit",
    profile_favs: "Notes Favorit",
    profile_dislikes: "Notes yang Tidak Disukai",
    profile_style: "Gaya Wewangian",
    profile_intensity: "Intensitas Preferensi",
    profile_occasion: "Momen Preferensi",
    profile_summary: "Ringkasan Konsultasi AI",
    profile_save: "Simpan profil",
    profile_saved: "Profil tersimpan.",
    profile_add: "Tambah",

    hist_title: "Riwayat Konsultasi AI",
    hist_sub: "Konsultasi Anda dengan PERSONA AI PERFUMER.",
    hist_empty: "Belum ada konsultasi. Mulai konsultasi pertama Anda.",
    hist_open: "Buka",
    hist_rename: "Ganti nama",
    hist_delete: "Hapus",
    hist_rename_prompt: "Judul baru",

    sub_page_title: "Langganan Saya",
    sub_current_plan: "Paket Aktif",
    sub_status: "Status",
    sub_renewal: "Tanggal perpanjangan",
    sub_usage: "Penggunaan AI",
    sub_upgrade: "Upgrade paket",
    sub_soon: "Upgrade akan segera hadir.",

    tech_title: "PERSONA PERFUMERY TECH",
    tech_headline: "Teknologi Wewangian Personal Resmi",
    tech_desc:
      "Akses teknologi riset dan formulasi wewangian personal resmi PERSONA.",
    tech_distinction_ai:
      "PERSONA AI PERFUMER = Intelijen dan konsultasi wewangian bertenaga AI.",
    tech_distinction_tech:
      "PERSONA PERFUMERY TECH = Teknologi wewangian personal resmi PERSONA.",
    tech_distinction_core:
      "PERSONA CORE = Teknologi proprietari terlindungi di balik PERSONA PERFUMERY TECH.",
    tech_cta: "AKSES TEKNOLOGI RESMI PERSONA",

    loading: "Memuat…",
    back: "Kembali",
  },

  fr: {
    nav_dashboard: "Tableau de bord",
    nav_ai_perfumer: "PERSONA AI PERFUMER",
    nav_profile: "Mon Profil AI",
    nav_history: "Historique des Consultations",
    nav_subscription: "Mon Abonnement",
    nav_account: "Compte",
    nav_tech: "PERSONA PERFUMERY TECH",
    nav_signin: "Connexion",
    nav_signup: "Commencer",
    nav_signout: "Déconnexion",

    hero_tagline: "L'intelligence derrière la parfumerie personnalisée",
    hero_headline_a: "Là où l'intelligence artificielle,",
    hero_headline_b: "le savoir parfumier et",
    hero_headline_c: "la parfumerie personnalisée",
    hero_headline_d: "se rencontrent.",
    hero_cta_primary: "EXPLORER PERSONA AI PERFUMER",
    hero_cta_secondary: "DÉCOUVRIR PERSONA PERFUMERY TECH",
    heritage_badge: "Conçu en Indonésie. Pensé pour le monde.",

    what_is_eyebrow: "La plateforme",
    what_is_title: "Qu'est-ce que PERSONA FRAGRANCE INTELLIGENCE ?",
    what_is_body:
      "Une plateforme premium d'intelligence olfactive alliant intelligence artificielle, savoir parfumier approfondi et technologie de parfumerie personnalisée — pour la nouvelle ère du parfum sur mesure.",

    products_eyebrow: "Deux produits, un écosystème",
    products_title: "L'intelligence AI rencontre la technologie parfumière officielle.",
    product_ai_subtitle: "Intelligence olfactive alimentée par l'IA",
    product_ai_desc:
      "Explorez le savoir parfumier, recevez une consultation intelligente et découvrez vos préférences olfactives grâce à une conversation IA.",
    product_ai_cta: "ENTRER DANS PERSONA AI PERFUMER",
    product_tech_subtitle: "Technologie officielle de parfumerie personnalisée",
    product_tech_desc:
      "Accédez à la technologie officielle de recherche et de formulation personnalisée PERSONA.",
    product_tech_cta: "ACCÉDER À PERSONA PERFUMERY TECH",

    eco_eyebrow: "Fonctionnement de l'écosystème",
    eco_title: "Un écosystème intelligent. Deux technologies fondamentales.",
    eco_ai_role: "Intelligence AI",
    eco_ai_kb: "Base de connaissances",
    eco_ai_cons: "Consultation",
    eco_ai_rec: "Recommandations",
    eco_tech_role: "Technologie officielle",
    eco_tech_core: "PERSONA CORE",
    eco_tech_res: "Recherche officielle",
    eco_tech_form: "Formule officielle",
    eco_core_note: "PERSONA CORE demeure une boîte noire propriétaire protégée.",

    why_eyebrow: "Pourquoi c'est important",
    why_title: "Le parfum personnalisé, sublimé par l'intelligence.",
    why_body:
      "La consultation parfumière traditionnelle est manuelle, inégale et difficile à mettre à l'échelle. PERSONA AI PERFUMER offre à chacun un guide olfactif structuré, intelligent et à la demande — partout dans le monde.",

    ai_eyebrow: "Intelligence olfactive alimentée par l'IA",
    ai_title: "Une expérience de consultation, pas un chatbot.",
    ai_bullet_1: "Découvrez vos familles olfactives",
    ai_bullet_2: "Comprenez notes, accords et structures",
    ai_bullet_3: "Construisez un AI Fragrance Profile vivant",
    ai_bullet_4: "Bahasa Indonesia, English & Français",

    sub_eyebrow: "Adhésion",
    sub_title: "Choisissez le niveau de votre voyage olfactif.",
    sub_free: "Gratuit",
    sub_free_desc: "Commencez votre découverte olfactive.",
    sub_pro: "Pro",
    sub_pro_desc: "Pour les passionnés de parfum.",
    sub_enterprise: "Enterprise",
    sub_enterprise_desc: "Pour professionnels et boutiques.",

    faq_title: "Questions fréquentes",
    faq_q1: "PERSONA AI PERFUMER est-il identique à PERSONA CORE ?",
    faq_a1:
      "Non. PERSONA AI PERFUMER est un conseiller olfactif IA. PERSONA CORE est la technologie propriétaire protégée derrière PERSONA PERFUMERY TECH et n'est pas exposée ici.",
    faq_q2: "L'IA génère-t-elle ma formule PERSONA officielle ?",
    faq_a2:
      "Non. L'IA fournit uniquement une intelligence olfactive et un guidage. Les résultats officiels personnalisés proviennent de PERSONA PERFUMERY TECH.",
    faq_q3: "Quelles langues sont prises en charge ?",
    faq_a3: "Bahasa Indonesia, English et Français — d'autres à venir.",
    faq_q4: "Dois-je partager des données biométriques à l'inscription ?",
    faq_a4: "Non. L'inscription est volontairement simple.",

    final_cta_title: "Commencez votre voyage d'intelligence olfactive.",
    final_cta_sub: "Deux produits. Un écosystème élégant. Un savoir-faire de calibre mondial.",
    final_cta_button: "Créer votre compte",

    auth_signin_title: "Connexion",
    auth_signin_sub: "Poursuivez votre voyage d'intelligence olfactive.",
    auth_signup_title: "Créer un compte",
    auth_signup_sub: "Commencez à explorer PERSONA FRAGRANCE INTELLIGENCE.",
    auth_email: "E-mail",
    auth_password: "Mot de passe",
    auth_name: "Nom complet",
    auth_signin_btn: "Se connecter",
    auth_signup_btn: "Créer le compte",
    auth_google: "Continuer avec Google",
    auth_or: "ou",
    auth_no_account: "Nouveau ici ?",
    auth_have_account: "Vous avez déjà un compte ?",
    auth_error: "Une erreur est survenue. Veuillez réessayer.",

    dash_welcome: "Bienvenue dans votre voyage d'intelligence olfactive.",
    dash_hello: "Bonjour",
    dash_ai_card_title: "PERSONA AI PERFUMER",
    dash_ai_card_sub: "Intelligence olfactive alimentée par l'IA",
    dash_ai_card_desc:
      "Explorez le savoir parfumier, recevez une consultation intelligente et découvrez vos préférences via une conversation IA.",
    dash_tech_card_title: "PERSONA PERFUMERY TECH",
    dash_tech_card_sub: "Technologie officielle de parfumerie personnalisée",
    dash_tech_card_desc:
      "Accédez à la technologie officielle de recherche et de formulation personnalisée PERSONA.",
    dash_stat_conversations: "Consultations",
    dash_stat_messages: "Messages IA",
    dash_stat_plan: "Formule active",

    ai_page_title: "PERSONA AI PERFUMER",
    ai_page_sub: "Votre conseiller olfactif intelligent",
    ai_input_placeholder: "Posez votre question olfactive…",
    ai_send: "Envoyer",
    ai_new_conversation: "Nouvelle consultation",
    ai_suggestions_title: "Essayez",
    ai_sugg_1: "Quel style de parfum me convient ?",
    ai_sugg_2: "Quelle est la différence entre les parfums boisés et floraux ?",
    ai_sugg_3: "Aidez-moi à découvrir mes préférences olfactives.",
    ai_sugg_4: "Quelles notes pourrais-je apprécier ?",
    ai_sugg_5: "Enseignez-moi les familles olfactives.",
    ai_disclaimer:
      "PERSONA AI PERFUMER fournit un guide olfactif IA. Pour votre résultat personnalisé officiel, utilisez PERSONA PERFUMERY TECH.",
    ai_thinking: "Composition de votre consultation…",

    profile_title: "Mon Profil AI",
    profile_sub: "AI Fragrance Profile — ce n'est pas le profil officiel PERSONA CORE.",
    profile_families: "Familles olfactives préférées",
    profile_favs: "Notes favorites",
    profile_dislikes: "Notes non appréciées",
    profile_style: "Style olfactif",
    profile_intensity: "Intensité préférée",
    profile_occasion: "Occasion préférée",
    profile_summary: "Résumé de consultation IA",
    profile_save: "Enregistrer le profil",
    profile_saved: "Profil enregistré.",
    profile_add: "Ajouter",

    hist_title: "Historique des consultations AI",
    hist_sub: "Vos consultations passées avec PERSONA AI PERFUMER.",
    hist_empty: "Aucune consultation. Lancez votre première consultation.",
    hist_open: "Ouvrir",
    hist_rename: "Renommer",
    hist_delete: "Supprimer",
    hist_rename_prompt: "Nouveau titre",

    sub_page_title: "Mon Abonnement",
    sub_current_plan: "Formule active",
    sub_status: "Statut",
    sub_renewal: "Date de renouvellement",
    sub_usage: "Utilisation IA",
    sub_upgrade: "Passer à un niveau supérieur",
    sub_soon: "Les mises à niveau seront bientôt disponibles.",

    tech_title: "PERSONA PERFUMERY TECH",
    tech_headline: "Technologie officielle de parfumerie personnalisée",
    tech_desc:
      "Accédez à la technologie officielle de recherche et de formulation personnalisée PERSONA.",
    tech_distinction_ai:
      "PERSONA AI PERFUMER = Intelligence et consultation olfactive IA.",
    tech_distinction_tech:
      "PERSONA PERFUMERY TECH = Technologie officielle de parfumerie personnalisée PERSONA.",
    tech_distinction_core:
      "PERSONA CORE = Technologie propriétaire protégée derrière PERSONA PERFUMERY TECH.",
    tech_cta: "ACCÉDER À LA TECHNOLOGIE PERSONA OFFICIELLE",

    loading: "Chargement…",
    back: "Retour",
  },
};

// Merge Phase 2 keys
["en", "id", "fr"].forEach((code) => {
  t[code] = { ...t[code], ...(P2[code] || {}), ...(P22[code] || {}), ...(P23[code] || {}), ...(P24[code] || {}), ...(P5[code] || {}) };
});

export default t;